module.exports = __webpack_public_path__ + "static/media/hp-login-banner-tablet-@2x.8b45ed1f.jpg";